var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("距离结束 "+_vm._s(_vm.countdown))])
}
var staticRenderFns = []

export { render, staticRenderFns }